import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { CARS_STATE } from '../../constants';

const useLocationSharingLoadingStatus = () => useSelector(
  (state: RootState) => state[CARS_STATE].locationSharing.loadingStatus
);

const useLocationSharingAddingStatus = () => useSelector(
  (state: RootState) => state[CARS_STATE].locationSharing.addingStatus
);

const useLocationSharingDeletingStatus = () => useSelector(
  (state: RootState) => state[CARS_STATE].locationSharing.deletingStatus
);

export const useIsLocationSharingLoading = () => {
  const locationSharingLoadingStatus = useLocationSharingLoadingStatus();
  return checkIsLoading(locationSharingLoadingStatus);
};

export const useIsLocationSharingDone = () => {
  const locationSharingLoadingStatus = useLocationSharingLoadingStatus();
  return checkIsLoadingDone(locationSharingLoadingStatus);
};

export const useIsLocationSharingAdding = () => {
  const locationSharingAddingStatus = useLocationSharingAddingStatus();
  return checkIsLoading(locationSharingAddingStatus);
};

export const useIsLocationSharingAddingDone = () => {
  const locationSharingAddingStatus = useLocationSharingAddingStatus();
  return checkIsLoadingDone(locationSharingAddingStatus);
};

export const useIsLocationSharingDeleting = () => {
  const locationSharingDeletingStatus = useLocationSharingDeletingStatus();
  return checkIsLoading(locationSharingDeletingStatus);
};

export const useIsLocationSharingDeletingDone = () => {
  const locationSharingDeletingStatus = useLocationSharingDeletingStatus();
  return checkIsLoadingDone(locationSharingDeletingStatus);
};

export const useLocationSharing = () => useSelector(
  (state: RootState) => state[CARS_STATE].locationSharing.data
);

export const useSelectedLocationSharingAutoNumber = () => useSelector(
  (state: RootState) => state[CARS_STATE].locationSharing.selectedAutoNumber
);

export const useLastAddedLocationSharing = () => {
  const locationSharing = useLocationSharing();
  const lastAddedId = useSelector((state: RootState) => state[CARS_STATE].locationSharing.lastAddedId);

  return useMemo(() => (
    (locationSharing || []).find(item => item.id === lastAddedId)
  ), [
    locationSharing,
    lastAddedId
  ]);
};

